var _style, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDibkLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "14 337 406 110",
    style: {
      enableBackground: "new 14 337 406 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:#003045;}\n\t.st2{fill:#89BAD6;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{display:inline;fill:#FFFFFF;}\n\t.st5{display:inline;fill:#D7D4D1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skisse__x28_forst\\xF8rret_x29_",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5_",
    x: 14,
    y: 337,
    className: "st1",
    width: 640,
    height: 110
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_82_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_80_",
    x: 14,
    y: 337,
    className: "st2",
    width: 150,
    height: 110
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_74_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_79_",
    className: "st3",
    points: "75.1,420.7 83.2,426.1 83.2,389.4 103,402.2 103,384 75.1,365.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_78_",
    className: "st3",
    points: "41.9,424.2 41.9,404.7 60.9,392.4 60.9,350.3 27.3,372.1 27.3,433.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_77_",
    className: "st3",
    points: "106.1,381.9 106.1,417.1 118.9,425.4 118.9,354.7 91.6,372.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_76_",
    className: "st3",
    points: "64,350.3 64,409.8 71.9,404.7 71.9,363.9 71.9,355.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_75_",
    className: "st3",
    points: "128.4,385.6 122.1,389.7 122.1,423.4 128.4,419.3 150.7,433.7 150.7,399.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_81_",
    x: 164.5,
    y: 367.5,
    className: "st1",
    width: 255.5,
    height: 79.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_44_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_71_",
    className: "st3",
    d: "M187.3,385.6h4.7c5.5,0,8.7,2.2,8.7,8.2s-4,8.2-8.7,8.2h-4.7V385.6z M191.9,399.4 c4.2,0,5.5-1.6,5.5-5.4c0-3.7-1.3-5.6-5.5-5.6h-1.5v11H191.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_69_",
    className: "st3",
    d: "M203.5,385.6h3.2v16.5h-3.2V385.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_66_",
    className: "st3",
    d: "M213.7,396h-0.2v6.1h-3.2v-16.5h4.7c3.8,0,6.4,1.4,6.4,4.9c0,2.8-1.7,4.6-4.4,5.2l5.6,6.3 h-3.8L213.7,396z M215,393.7c2,0,3.2-1,3.2-2.9c0-1.9-1.2-2.7-3.2-2.7h-1.5v5.5h1.5V393.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_64_",
    className: "st3",
    d: "M224.6,385.6h10.5v2.7h-7.3v4h4.9v2.5h-4.9v4.5h7.3v2.7h-10.5V385.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_62_",
    className: "st3",
    d: "M238,385.6h3.2v7.4l6.5-7.3h3.3l-5.9,6.6l6.3,9.9h-3.6l-4.7-7.7l-1.9,2.1v5.5H238V385.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_60_",
    className: "st3",
    d: "M256.8,388.4H252v-2.7h12.6v2.7H260v13.7h-3.2V388.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_57_",
    className: "st3",
    d: "M265.7,393.9c0-5.7,4-8.6,8.1-8.6c4.8,0,8.1,3,8.1,8.6c0,5.7-4,8.6-8.1,8.6 C269,402.5,265.7,399.6,265.7,393.9z M278.7,394c0-3.9-1.9-6-4.8-6s-4.8,2.1-4.8,5.8c0,3.9,1.9,6.1,4.8,6.1 C276.7,399.8,278.7,397.7,278.7,394z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    className: "st3",
    d: "M288,396h-0.2v6.1h-3.2v-16.5h4.7c3.8,0,6.4,1.4,6.4,4.9c0,2.8-1.7,4.6-4.4,5.2l5.6,6.3 h-3.8L288,396z M289.3,393.7c2,0,3.2-1,3.2-2.9c0-1.9-1.2-2.7-3.2-2.7h-1.5v5.5h1.5V393.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    className: "st3",
    d: "M303.1,387.3l-0.6-1.7h3.3l6.5,16.5H309l-1.3-3.4h-6.1l-1.3,3.4h-3.1L303.1,387.3z  M302.5,396.4h4.4l-1.7-4.5l-0.5-1.4l-0.5,1.4L302.5,396.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    className: "st3",
    d: "M316,388.4h-4.7v-2.7h12.6v2.7h-4.7v13.7H316V388.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    className: "st3",
    d: "M326.2,385.6h10.5v2.7h-7.3v4h4.9v2.5h-4.9v4.5h7.3v2.7h-10.5V385.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_45_",
    className: "st3",
    d: "M343.1,388.4h-4.7v-2.7H351v2.7h-4.7v13.7h-3.2L343.1,388.4L343.1,388.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    className: "st3",
    d: "M187.3,412.3h10.3v2.7h-7.1v4.1h4.7v2.4h-4.7v7.2h-3.2V412.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    className: "st3",
    d: "M198.8,420.5c0-5.7,4-8.6,8.1-8.6c4.8,0,8.1,3,8.1,8.6c0,5.7-4,8.6-8.1,8.6 C202.1,429.1,198.8,426.2,198.8,420.5z M211.7,420.6c0-3.9-1.9-6-4.8-6c-2.9,0-4.8,2.1-4.8,5.8c0,3.9,1.9,6.1,4.8,6.1 C209.8,426.4,211.7,424.3,211.7,420.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st3",
    d: "M221.1,422.6h-0.2v6.1h-3.2v-16.4h4.7c3.8,0,6.4,1.4,6.4,4.9c0,2.8-1.7,4.6-4.4,5.2l5.6,6.3 h-3.8L221.1,422.6z M222.4,420.3c2,0,3.2-1,3.2-2.9s-1.2-2.7-3.2-2.7h-1.5v5.5L222.4,420.3L222.4,420.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    className: "st3",
    d: "M237.8,412.3h4.9c4.5,0,6.4,1.5,6.4,4.1c0,2.3-1.3,3.4-3.1,3.8l0,0c2,0.3,3.3,1.3,3.3,3.9 s-1.8,4.7-6.5,4.7h-5L237.8,412.3L237.8,412.3z M242.8,419c2.4,0,3.1-0.8,3.1-2.2c0-1.4-0.9-2-3.1-2H241v4.2H242.8z M243,426.1 c2.4,0,3.2-0.8,3.2-2.3c0-1.4-0.8-2.3-3.2-2.3h-2v4.5h2V426.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    className: "st3",
    d: "M255.5,422l-5.4-9.7h3.5l3.6,6.9l3.7-6.9h3.2l-5.4,9.7v6.8h-3.2L255.5,422L255.5,422z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st3",
    d: "M264.5,420.5c0-5.7,3.6-8.6,8-8.6c2.7,0,4.3,0.8,5.2,1.6v3.6c-0.9-1.4-2.4-2.4-4.8-2.4 c-3.3,0-5.2,2-5.2,5.7s1.8,6.2,4.7,6.2c0.8,0,1.5-0.1,2.1-0.3v-5.1h3.2v6.6c-1.1,0.7-2.9,1.4-5.4,1.4 C267.7,429.1,264.5,426.3,264.5,420.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st3",
    d: "M280,420.5c0-5.7,3.6-8.6,8-8.6c2.7,0,4.3,0.8,5.2,1.6v3.6c-0.9-1.4-2.4-2.4-4.8-2.4 c-3.3,0-5.2,2-5.2,5.7s1.8,6.2,4.7,6.2c0.8,0,1.5-0.1,2.1-0.3v-5.1h3.2v6.6c-1.1,0.7-2.9,1.4-5.4,1.4 C283.2,429.1,280,426.3,280,420.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    className: "st3",
    d: "M296.5,412.3h3.2v7.3l6.5-7.3h3.3l-5.9,6.6l6.3,9.9h-3.6l-4.7-7.7l-1.9,2.1v5.5h-3.2 L296.5,412.3L296.5,412.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_22_",
    className: "st3",
    d: "M310.1,412.3h3.3l3.9,11.5h0.1l4-11.5h3.1l-5.9,16.5H316L310.1,412.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st3",
    d: "M329.2,413.9l-0.6-1.7h3.3l6.5,16.5h-3.3l-1.3-3.4h-6.1l-1.3,3.4h-3.1L329.2,413.9z  M328.6,423h4.4l-1.7-4.5l-0.5-1.4l-0.5,1.4L328.6,423z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st3",
    d: "M340.4,412.3h3.2V426h6.1v2.8h-9.3L340.4,412.3L340.4,412.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st3",
    d: "M352.1,412.3h3.2v16.5h-3.2V412.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st3",
    d: "M362.3,415h-4.7v-2.7h12.6v2.7h-4.7v13.7h-3.2L362.3,415L362.3,415z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st3",
    d: "M372.6,412.3h10.5v2.7h-7.3v3.9h4.9v2.5h-4.9v4.6h7.3v2.7h-10.5V412.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st3",
    d: "M389.4,415h-4.7v-2.7h12.6v2.7h-4.7v13.7h-3.2L389.4,415L389.4,415z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hamburgermeny",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_94_",
    x: 578,
    y: 386,
    className: "st4",
    width: 60,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_95_",
    x: 578,
    y: 423,
    className: "st4",
    width: 60,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_96_",
    x: 578,
    y: 405,
    className: "st4",
    width: 60,
    height: 6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "hamburgermeny__hover",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_97_",
    x: 578,
    y: 386,
    className: "st5",
    width: 60,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_93_",
    x: 578,
    y: 423,
    className: "st5",
    width: 60,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_91_",
    x: 578,
    y: 405,
    className: "st5",
    width: 60,
    height: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDibkLogoMobile);
export default __webpack_public_path__ + "static/media/dibk-logo-mobile.08fe5b620dcadeebd9bba108c390e56c.svg";
export { ForwardRef as ReactComponent };